import {
	type ContextModalProps,
	ModalsProvider as MantineModalsProvider,
} from "@mantine/modals";
import { InviteCollaboratorPopover } from "@src/components/mentions/modals/invite-collaborator-modal";
import type { ReactNode } from "react";

function ModalWithButtons({
	innerProps,
}: ContextModalProps<{ children: ReactNode; buttons?: ReactNode }>) {
	return (
		<>
			{innerProps.children}
			{innerProps.buttons}
		</>
	);
}

export function ModalsProvider(props: { children: ReactNode }) {
	return (
		<MantineModalsProvider modals={{ buttonsModal: ModalWithButtons }}>
			{props.children}
			<InviteCollaboratorPopover />
		</MantineModalsProvider>
	);
}

const modals = {
	buttonsModal: ModalWithButtons,
};

declare module "@mantine/modals" {
	export interface MantineModalsOverride {
		modals: typeof modals;
	}
}
